import { render, staticRenderFns } from "./Profile.component.vue?vue&type=template&id=0da832b6&"
import script from "./Profile.component.vue?vue&type=script&lang=ts&"
export * from "./Profile.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports